export const orderKeys = {
  all: ["orders"] as const,
  lists: () => [...orderKeys.all, "list"] as const,
  list: (filters: string) => [...orderKeys.lists(), { filters }] as const,
  failed: () => [...orderKeys.lists(), "failed"] as const,
  details: () => [...orderKeys.all, "detail"] as const,
  detail: (id: number | undefined) => [...orderKeys.details(), id] as const,
  confirmation: (id: number | undefined) =>
    [...orderKeys.detail(id), "confirmation"] as const,
}

export const alternateOfferKeys = {
  all: ["alternateOffers"] as const,
  details: () => [...alternateOfferKeys.all, "detail"] as const,
  detail: (id: number) => [...alternateOfferKeys.details(), id] as const,
}
